"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendEve = exports.tick = exports.buildEveRequestBody = exports.buildBody = exports.interactionToPerfEvent = exports.flatten = exports.measurementsToPerfEvent = exports.counterToCounterEvent = exports.stopEveSendLoop = exports.startEveSendLoop = exports.setSessionAttributes = exports.initEveClient = undefined;

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _performanceTracker = require("./performance-tracker");

var _errorTracking = require("./error-tracking");

var _uuid = require("uuid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEND_LOOP_INTERVAL = 8000;

var config = null;
var sessionAttributes = null;

var sessionId = (0, _uuid.v4)();

var addErrorEvents = function addErrorEvents() {
  if (!window || !window.addEventListener) {
    console.error("Not running in a browser, can't instrument error events.");
    return;
  }

  window.addEventListener("unhandledrejection", function (event) {
    (0, _errorTracking.logUnhandledRejection)(event);
    sendEve();
  });

  window.addEventListener("error", function (event) {
    (0, _errorTracking.logUnhandledError)(event);
    sendEve();
  });
};

var initEveClient = exports.initEveClient = function initEveClient(eveBaseUrl, jwt, userGuid, orgGuid, clientApp, clientAppVersion) {
  var startPolling = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  var instrumentErrors = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
  var wrapFetch = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;

  config = {
    eveBaseUrl: eveBaseUrl,
    jwt: jwt,
    userGuid: userGuid,
    orgGuid: orgGuid,
    clientApp: clientApp,
    clientAppVersion: clientAppVersion
  };
  if (wrapFetch && !window.oldFetch) {
    // Create new fetch wrapper to log unhandled errors
    var oldFetch = window.fetch;

    var newFetch = function newFetch() {
      var url = arguments.length <= 0 ? undefined : arguments[0];
      return oldFetch.apply(undefined, arguments).catch(function (err) {
        (0, _errorTracking.logUnhandledError)(err, { url: url });
        throw err;
      });
    };
    // Replace the original fetch with our new one.
    window.fetch = newFetch;
    window.oldFetch = oldFetch;
  }

  startPolling && startEveSendLoop();
  instrumentErrors && addErrorEvents();
};

var setSessionAttributes = exports.setSessionAttributes = function setSessionAttributes(attributes) {
  sessionAttributes = attributes;
};

var eveInterval = null;
var startEveSendLoop = exports.startEveSendLoop = function startEveSendLoop() {
  eveInterval = setInterval(tick, SEND_LOOP_INTERVAL);
};

var stopEveSendLoop = exports.stopEveSendLoop = function stopEveSendLoop() {
  clearInterval(eveInterval);
};

var counterToCounterEvent = function counterToCounterEvent(counter) {
  var name = counter.name,
      attributes = (0, _objectWithoutProperties3.default)(counter, ["name"]);

  return (0, _extends3.default)({
    eventType: name
  }, attributes);
};

exports.counterToCounterEvent = counterToCounterEvent;
var measurementsToPerfEvent = function measurementsToPerfEvent(measurement) {
  var name = measurement.name,
      attributes = (0, _objectWithoutProperties3.default)(measurement, ["name"]);

  return (0, _extends3.default)({
    eventType: name
  }, attributes);
};

// EdgeHTML doesn't have Array.flat()
exports.measurementsToPerfEvent = measurementsToPerfEvent;
var flatten = exports.flatten = function flatten(mdArray) {
  return mdArray.reduce(function (prev, curr) {
    return prev.concat(curr);
  }, []);
};

var interactionToPerfEvent = function interactionToPerfEvent(interaction) {
  var name = interaction.name,
      elapsed = interaction.elapsed,
      segments = interaction.segments,
      active = interaction.active,
      lastUpdate = interaction.lastUpdate,
      start = interaction.start,
      timingStrategy = interaction.timingStrategy,
      attributes = (0, _objectWithoutProperties3.default)(interaction, ["name", "elapsed", "segments", "active", "lastUpdate", "start", "timingStrategy"]);

  return flatten([(0, _extends3.default)({
    eventType: name,
    measure1: elapsed
  }, attributes), segments.map(function (segment) {
    return {
      eventType: name,
      eventSubType: segment.name,
      measure2: segment.elapsed
    };
  })]);
};

exports.interactionToPerfEvent = interactionToPerfEvent;
var errorToCounterEvent = function errorToCounterEvent(error) {
  return (0, _keys2.default)(error).filter(function (key) {
    return !!error[key];
  }).reduce(function (acc, key) {
    acc[key] = error[key];
    return acc;
  }, {});
};

var buildBody = exports.buildBody = function buildBody(interactions, counters, measurements, errors) {
  return {
    userContext: (0, _extends3.default)({
      userGuid: config.userGuid,
      orgGuid: config.orgGuid,
      clientApp: config.clientApp,
      clientAppVersion: config.clientAppVersion,
      session: sessionId
    }, sessionAttributes),
    perfEvents: [].concat((0, _toConsumableArray3.default)(flatten(interactions.map(interactionToPerfEvent))), (0, _toConsumableArray3.default)(measurements.map(measurementsToPerfEvent))),
    counters: [].concat((0, _toConsumableArray3.default)(counters.map(counterToCounterEvent)), (0, _toConsumableArray3.default)(errors.map(errorToCounterEvent)))
  };
};

var buildEveRequestBody = exports.buildEveRequestBody = function buildEveRequestBody() {
  var interactions = (0, _performanceTracker.getInteractions)(true);
  var interactionsToSend = interactions.filter(function (interaction) {
    return !interaction.active;
  });

  var errors = (0, _errorTracking.getLoggedErrors)(true);

  var counters = (0, _performanceTracker.getCounters)();
  (0, _performanceTracker.clearCounters)();

  var measurements = (0, _performanceTracker.getMeasurements)();
  (0, _performanceTracker.clearMeasurements)();

  if (interactionsToSend.length === 0 && counters.length === 0 && measurements.length === 0 && errors.length === 0) {
    return undefined;
  }

  return buildBody(interactionsToSend, counters, measurements, errors);
};

var tick = exports.tick = function tick() {
  return sendEve().catch(function (e) {
    return true;
  });
}; // Ignore eve errors. We'll auto-stop sending after 10

var sendErrors = 0;
var sendEve = exports.sendEve = function sendEve() {
  var body = buildEveRequestBody();

  if (!body) {
    return _promise2.default.resolve("no work to do");
  }

  if (sendErrors > 9) {
    console.warn("EVE: Hit the send error limit (10), stopping.");
    stopEveSendLoop();
    return;
  }

  var oldFetch = window.fetch;

  // check if fetch was overridden
  var fetchCall = oldFetch || fetch;

  return fetchCall(config.eveBaseUrl + "/api/report", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + config.jwt,
      "Content-Type": "application/json"
    },
    body: (0, _stringify2.default)(body)
  }).then(function (result) {
    return result.json();
  }).then(function (body) {
    if (body.result !== "ok") {
      sendErrors++;
      console.warn("EVE: could not send to eve", body);
    }
    return body;
  }).catch(function (e) {
    sendErrors++;
    console.warn("EVE: could not send to eve", e, sendErrors);
    throw e;
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/eve-client/dist/eve.js
// module id = 905
// module chunks = 0